<template>
  <div>
    <v-dialog v-model="dialog" width="900px" class="color" @click:outside="cancel">
      <v-card>
        <v-card-title class="primary white--text">
          <v-toolbar-title>CHI TIẾT CÁC KHOẢN NỢ</v-toolbar-title>
          <v-spacer />
          <v-icon color="white" @click="cancel">close</v-icon>
        </v-card-title>
        <v-card-text id="element-to-convert">
          <v-card class="mt-4">
            <v-data-table
              mobile-breakpoint="0"
              item-key="id"
              :items-per-page="5"
              :headers="header"
              :items="items"
              sort-by="name"
              :loading="loading"
              loading-text="Đang Tải"
              :hide-default-footer="!items[0]"
            >
              <!-- <template v-slot:[`item.name`]="{ item }">
                <CardStudentName :student="item.student" link />
              </template> -->
              <template v-slot:[`item.period`]="{ item }">
                <span>{{ item.period.title }}</span>
              </template>
              <template v-slot:[`item.totalAmount`]="{ item }">
                {{ item.totalAmount.toLocaleString('en-US') }}
              </template>
              <template v-slot:[`item.amountPaid`]="{ item }">
                {{ item.amountPaid.toLocaleString('en-US') }}
              </template>
              <template v-slot:[`item.amountDue`]="{ item }">
                <span class="fee">{{ item.amountDebt.toLocaleString('en-US') }}</span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn icon @click="() => openDetailDebt(item)" v-bind="attrs" v-on="on">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mt-5">
          <v-btn color="primary" class="px-6 mr-2 mt-n4 mb-2 white--text d-none" @click="cancel">ĐÓNG</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { TuitionFeeReport } from '@/plugins/api'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
export default {
  components: {
    CardStudentName,
  },
  data() {
    return {
      dialog: false,
      items: [],
      loading: false,
      header: [
        {
          text: 'Kì đóng',
          value: 'period',
          align: 'left',
          sortable: false,
          show: true,
          width: '12%',
        },
        {
          text: 'Số tiền phải đóng',
          value: 'totalAmount',
          align: 'right',
          sortable: false,
          show: true,
          width: '12%',
        },
        {
          text: 'Số tiền đã đóng',
          value: 'amountPaid',
          align: 'right',
          sortable: false,
          show: true,
          width: '12%',
        },
        {
          text: 'Số tiền còn nợ',
          value: 'amountDue',
          align: 'right',
          sortable: false,
          show: true,
          width: '12%',
        },
      ],
    }
  },
  methods: {
    async openDialog(debt) {
      try {
        this.loading = true
        this.dialog = true
        let reports = await TuitionFeeReport.fetch({ student: debt.student._id })
        reports = reports.filter(i => i.amountDue > 0 || i.amountOver > 0)
        this.items = reports
      } finally {
        this.loading = false
      }
    },
    cancel() {
      this.dialog = false
      this.items = []
    },
  },
}
</script>

<style>
.fee {
  color: #fd6b6b !important;
  font-weight: 500;
}
</style>
